import React from "react";
import "./adddetailsbyweight.css";
import TextFeild from "../../../CustomTextFeild/TextFeild";
import { useTranslation } from "react-i18next";

const AddDetailsByWeight = ({
  addDetail,
  handleChangeDetails,
  formulaDetails,
  tierFormula,
}) => {
  const { t } = useTranslation(["warehouse", "common"]);
  return (
    <>
      <div className="details_byweight_formrow">
        <div className="">
          <TextFeild
            Name="min"
            Label={t("fulfilmentTier.min")}
            Required={false}
            Disabled={tierFormula?.formula_details?.length === 0}
            Data={formulaDetails.min}
            Adroment={tierFormula?.unit}
            Handler={(e) => handleChangeDetails(e)}
          />
        </div>
        <div className="">
          <TextFeild
            Label={t("fulfilmentTier.max")}
            Data={formulaDetails.max}
            Name="max"
            Required={false}
            Adroment={tierFormula?.unit}
            Handler={(e) => handleChangeDetails(e)}
          />
        </div>

        <button
          className="details_byweight_modalsave details_byweight_details"
          onClick={(e) => addDetail(e)}
        >
          <span>{t("common:actions.add")} </span> +
        </button>
      </div>
    </>
  );
};

export default AddDetailsByWeight;
